(() => {
  angular
    .module('app')
    .controller('common.views.queryFollowUpLog.addRemarkModal', AddRemarkModalController);

  AddRemarkModalController.$inject = [
    '$uibModalInstance',
    'abp.services.app.serviceRequestQuery',
    'Hms.ServiceRequests.ServiceRequestQueryFollowUp',
    'queryId',
  ];

  function AddRemarkModalController(
    $uibModalInstance,
    serviceRequestQuerySvc,
    constsServiceRequestQueryFollowUp,
    queryId
  ) {
    const vm = this;

    vm.saving = 0;
    vm.remark = '';
    vm.maxLength = constsServiceRequestQueryFollowUp.MaxTextLength;

    vm.remarkLength = remarkLength;
    vm.isOverLimit = isOverLimit;
    vm.overLimitMessage = overLimitMessage;
    vm.canSave = canSave;
    vm.save = save;
    vm.cancel = cancel;

    /* Functions */

    // Counted as the server will record it — without surrounding whitespace.
    function remarkLength() {
      return (vm.remark || '').trim().length;
    }

    function isOverLimit() {
      return remarkLength() > vm.maxLength;
    }

    function overLimitMessage() {
      return App.localize('FollowUpRemarkTooLong', remarkLength() - vm.maxLength, vm.maxLength);
    }

    function canSave() {
      return !vm.saving && remarkLength() > 0 && !isOverLimit();
    }

    function save() {
      if (!canSave()) return;

      vm.saving += 1;
      serviceRequestQuerySvc
        .addFollowUpRemark({ id: queryId, text: vm.remark.trim() })
        .success(() => {
          abp.notify.success(App.localize('SuccessfullySaved'));
          $uibModalInstance.close();
        })
        .finally(() => {
          vm.saving -= 1;
        });
    }

    function cancel() {
      $uibModalInstance.dismiss();
    }
  }
})();
